import highLowEncoding from "../snippets/highLowEncoding";

export default `
precision highp float;

uniform sampler2D previousTrails;
uniform sampler2D imprint;
uniform sampler2D noise;
uniform vec2 positionOffset;
uniform float time;
uniform float additionTrailFade;

varying vec2 vUv;
varying vec2 vPosition;

${highLowEncoding()}

float easeOutExpo(float x) {
    return 1.0 - pow(2.0, -12.0 * x);
}

#define granularity 20.0
#define distortionLevel 0.0020

void main() {
	vec2 distortedUv = vUv + vec2(time);
	vec4 noise = texture2D(noise, distortedUv * granularity);
	noise = noise * 2.0 - 1.0;
	vec2 noiseOffset = noise.xy * distortionLevel;
	vec4 imprint = texture2D(imprint, vUv + noiseOffset);
	float trailDepth = imprint.r;
	
	vec2 reducedNoiseOffset = noiseOffset * 0.0015;
	vec2 maybeOffsetUv = vUv + positionOffset;
	vec4 previousTrail = texture2D(previousTrails, maybeOffsetUv + reducedNoiseOffset);
	//vec4 previousTrail = texture2D(previousTrails, maybeOffsetUv);

	//Need to encode depth accross two values in order for it to have space to degrade at the virus rate
	float decodedPreviousTrail = highLowDecode(previousTrail.gb);
	
	//Find out if this is a virus from either the imprint g value or the previous trail r value
	float imprintIsVirus = imprint.g == 0.0 && imprint.b > 0.0 ? 1.0 : 0.0;
	float previousIsVirus = previousTrail.r;
	float isVirus = max(imprintIsVirus, previousIsVirus);

	//Viruses trails degrade much slower
	float downStep;
	if(isVirus < 1.0) {
		downStep = 0.06; //Changed
	}
	else {
		downStep = mix(0.06, 0.000001, easeOutExpo(1.0 - decodedPreviousTrail));
	}
	downStep += additionTrailFade;

	if(previousIsVirus > imprintIsVirus) {
		trailDepth = 0.0;
	}
	
	float previousTrailDepth = max(0.0, decodedPreviousTrail - downStep);

	if(maybeOffsetUv.x < 0.0 || maybeOffsetUv.y < 0.0 || maybeOffsetUv.x > 1.0 || maybeOffsetUv.y > 1.0) {
		trailDepth = 0.0;
	}

	trailDepth = max(trailDepth, previousTrailDepth);

	vec2 encodedTrail = highLowEncode(trailDepth); //The trail degradation is so slow 256 values is not enough
		
	gl_FragColor = vec4(isVirus, encodedTrail.x, encodedTrail.y, 1.0);	
}`;